module.exports = "/fonts/NeoSansStd-Regular.woff?091630e4c8a87ac226b49e2ccc4dfa25";